import { useMutation } from '@tanstack/react-query'
import { showNotification } from '@mantine/notifications'
import { useOrpc } from './useClient'

/**
 * Writes a practitioner's Credentials (NPI + licenses) through Provider Operations. The
 * middleware refuses a practitioner outside the caller's scope.
 */
export function useUpdatePractitionerCredentials() {
  const orpc = useOrpc()

  return useMutation(
    orpc.updatePractitionerCredentials.mutationOptions({
      onSuccess: () => {
        showNotification({
          color: 'green',
          title: 'Credentials updated',
          message: 'Member credentials saved.',
        })
      },
      onError: (error) => {
        showNotification({
          color: 'red',
          title: 'Update failed',
          message: error instanceof Error ? error.message : 'Unknown error',
        })
      },
    }),
  )
}
